export const DATEPICKER_TOGGLE_ARIA_LABEL = 'Select transaction date'

/**
 * b-form-datepicker button-only mode renders an icon-only toggle without a name.
 * WCAG 4.1.2: set aria-label on each calendar trigger button.
 */
export function applyDatepickerToggleAriaLabels (root, label = DATEPICKER_TOGGLE_ARIA_LABEL) {
  if (!root || typeof root.querySelectorAll !== 'function') {
    return
  }

  root.querySelectorAll(
    '.b-form-datepicker button.btn.dropdown-toggle.dropdown-toggle-no-caret'
  ).forEach((button) => {
    button.setAttribute('aria-label', label)
  })
}



// WEBPACK FOOTER //
// ./src/utils/datepickerAccessibility.js